import {SupportedLocales} from '@gl/lit/types/locale.js';

export const exportActivitiesLocale = {
  [SupportedLocales.EN]: {
    activitiesTable: {
      columns: {
        destination: {
          label: 'Destination',
          tooltip: '',
        },
        status: {
          label: 'Status',
          tooltip: '',
        },
        exportTime: {
          label: 'Export Time',
          tooltip: '',
        },
        added: {
          label: 'Added',
          tooltip:
            'This count represents the number of records added to the audience and sent to the destination',
        },
        removed: {
          label: 'Removed',
          tooltip:
            'This count represents the number of records removed from the audience because they no longer meet the specified criteria',
        },
        rejected: {
          label: 'Rejected',
          tooltip:
            'This count represents the number of records that were attempted to be sent but failed due to errors or issues during processing. See "Error" column for info',
        },
        exportId: {
          label: 'Export ID',
          tooltip: '',
        },
        errorDetails: {
          label: 'Error Details',
          tooltip: '',
        },
      },
      noMatches: {
        headline: 'There are no activities.',
        caption: "Looks like you have no exports or they haven't started yet.",
      },
    },
    journeyActivitiesTable: {
      noMatches: {
        headline: 'Your journey is processing',
        caption: 'Activity will display here shortly',
      },
      noMatchesManual: {
        headline: 'No activity',
        caption:
          'Your journey is in manual mode. Once you run a journey, step activity will appear here',
      },
    },
    audienceExports: {
      nowSelected:
        "Setting the start-time to NOW, will run your export at the same time as 'now' based on the frequency selected",
    },
  },
  [SupportedLocales.ES]: {
    activitiesTable: {
      columns: {
        destination: {
          label: 'Destino',
          tooltip: '',
        },
        status: {
          label: 'Estado',
          tooltip: '',
        },
        exportTime: {
          label: 'Hora de exportación',
          tooltip: '',
        },
        added: {
          label: 'Agregados',
          tooltip:
            'Esta cuenta representa el número de registros agregados a la audiencia y enviados al destino',
        },
        removed: {
          label: 'Eliminados',
          tooltip:
            'Esta cuenta representa el número de registros eliminados de la audiencia porque ya no cumplen con los criterios especificados',
        },
        rejected: {
          label: 'Rechazados',
          tooltip:
            'Esta cuenta representa el número de registros que se intentaron enviar pero fallaron debido a errores o problemas durante el procesamiento. Ver la columna "Error" para obtener información',
        },
        exportId: {
          label: 'Export ID',
          tooltip: '',
        },
        errorDetails: {
          label: 'Error Details',
          tooltip: '',
        },
      },
      noMatches: {
        headline: 'Tu viaje se está procesando',
        caption: 'La actividad se mostrará aquí en breve',
      },
    },
    journeyActivitiesTable: {
      noMatches: {
        headline: 'No hay actividades de paso',
        caption: 'Aún no tienes ninguna actividad para este viaje.',
      },
      noMatchesManual: {
        headline: 'No hay actividad',
        caption:
          'Tu viaje está en modo manual. Una vez que ejecutes un paso de viaje, la actividad aparecerá aquí',
      },
    },
    audienceExports: {
      nowSelected:
        "Configurar la hora de inicio en AHORA, ejecutará tu exportación al mismo tiempo que 'ahora' según la frecuencia seleccionada",
    },
  },
};
